import { CampaignQueryContextProvider } from 'modules/templateEditor/context/CampaignQueryContextProvider';
import { TemplateQueryContextProvider } from 'modules/templateEditor/context/TemplateQueryContextProvider';
import { SendTestMsgContextProvider } from 'modules/templateEditor/context/SendTestMsgContextProvider';
import { ModalProvider } from 'modules/templateEditor/context';
import { Modals } from 'modules/templateEditor/modals';

import { TemplateStateContextProvider } from '../TemplateStateContextProvider';
import { PreviewWithDataContextProvider, EditTemplatePreviewContextProvider } from './index';

export const TemplatePreviewContextProvider: React.FC<
  React.PropsWithChildren<{ campaignId: number; selectedVariantTemplateId: number }>
> = ({ children, ...props }) => (
  <TemplateStateContextProvider
    {...{ campaignId: props.campaignId, templateId: props.selectedVariantTemplateId }}
  >
    <CampaignQueryContextProvider>
      <TemplateQueryContextProvider>
        <EditTemplatePreviewContextProvider>
          <PreviewWithDataContextProvider>
            <ModalProvider>
              <SendTestMsgContextProvider>
                {children}
                <Modals />
              </SendTestMsgContextProvider>
            </ModalProvider>
          </PreviewWithDataContextProvider>
        </EditTemplatePreviewContextProvider>
      </TemplateQueryContextProvider>
    </CampaignQueryContextProvider>
  </TemplateStateContextProvider>
);
